const DATE_PICKER_REG_EXP = /((2(\d{1,3})?)|(19[789]\d)-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
const NOT_VALID = 'not valid value';
export { DATE_PICKER_REG_EXP, NOT_VALID };
